// =============================================================================
// DropdownAcoes — menu "Ações" (botão + lista suspensa) para agrupar ações soltas
// =============================================================================
// Substitui vários botões/links espalhados por um único menu "Ações". Ícones são
// componentes lucide (nada de emoji). Fecha ao clicar fora ou escolher um item.
// =============================================================================

import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface AcaoItem {
  label: string;
  onClick: () => void;
  icon?: LucideIcon;
  disabled?: boolean;
  title?: string;
  /** destaca em vermelho (ação destrutiva) */
  perigo?: boolean;
}

interface Props {
  itens: AcaoItem[];
  label?: string;
  align?: 'left' | 'right';
  disabled?: boolean;
}

export default function DropdownAcoes({ itens, label = 'Ações', align = 'right', disabled }: Props) {
  const [aberto, setAberto] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        disabled={disabled}
        onClick={() => setAberto((v) => !v)}
        className="text-xs font-medium text-slate-600 bg-slate-100 px-3 py-1.5 rounded-lg hover:bg-slate-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors inline-flex items-center gap-1.5"
      >
        {label}
        <ChevronDown size={14} className={`transition-transform ${aberto ? 'rotate-180' : ''}`} />
      </button>

      {aberto && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setAberto(false)} />
          <div
            className={`absolute z-50 mt-1 min-w-[200px] bg-white rounded-xl shadow-lg border border-slate-200 py-1 ${
              align === 'right' ? 'right-0' : 'left-0'
            }`}
          >
            {itens.map((item, i) => {
              const Icone = item.icon;
              return (
                <button
                  key={i}
                  type="button"
                  title={item.title}
                  disabled={item.disabled}
                  onClick={() => { setAberto(false); item.onClick(); }}
                  className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
                    item.perigo
                      ? 'text-red-600 hover:bg-red-50'
                      : 'text-slate-700 hover:bg-slate-50'
                  }`}
                >
                  {Icone && <Icone size={16} className={item.perigo ? '' : 'text-slate-400'} />}
                  {item.label}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
